import { createAction, props } from '@ngrx/store';
import { AcceptanceRuleFieldDisplayTextTargetEnum } from '../../api/enums/acceptance-rule-field-display-text-target-enum.enum';
import { AcceptanceRuleLookupsDto } from '../../api/models/acceptance-rule-lookups-dto.model';

export const getAcceptanceRuleLookups = createAction(
    '[COMPLIANCE REQUIREMENT DESCRIPTIONS ACCEPTANCE RULE LOOKUPS] Get Acceptance Rule Lookups',
    props<{
        documentTypeId: number;
        displayTextTarget: AcceptanceRuleFieldDisplayTextTargetEnum;
        isSmartDescriptionsEnabled: boolean;
    }>()
);

export const getAcceptanceRuleLookupsSuccess = createAction(
    '[COMPLIANCE REQUIREMENT DESCRIPTIONS ACCEPTANCE RULE LOOKUPS] Get Acceptance Rule Lookups Success',
    props<{ acceptanceRuleLookups: AcceptanceRuleLookupsDto }>()
);

export const getAcceptanceRuleLookupsFailure = createAction(
    '[COMPLIANCE REQUIREMENT DESCRIPTIONS ACCEPTANCE RULE LOOKUPS] Get Acceptance Rule Lookups Failure',
    props<{ error: unknown }>()
);

export const setAcceptanceRuleLookupsIsLoadingFlag = createAction(
    '[COMPLIANCE REQUIREMENT DESCRIPTIONS ACCEPTANCE RULE LOOKUPS] Set Acceptance Rule Lookups IsLoading Flag',
    props<{
        isLoading: boolean;
    }>()
);
